import { render } from "./IconAssist.vue?vue&type=template&id=b18ac6ba&ts=true"
import script from "./IconAssist.vue?vue&type=script&lang=ts"
export * from "./IconAssist.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__